<mat-accordion class="headers-align">
    <mat-expansion-panel [expanded]="patientsArray.length < 2" (afterCollapse)="markCustomerFormsTouched()">
        <mat-expansion-panel-header
            [style.background-color]="!areRequiredCustomerFieldsComplete && hasTouchedRequiredCustomerFields ? 'rgb(237 20 61 / 20%)' : ''">
            <mat-panel-title>
                {{toTitle(form.controls['customerInformation'].get('title')?.value)}} {{form.controls['customerInformation'].get('lastName')?.value || ''}}
            </mat-panel-title>
            <mat-panel-description>Customer

            @if (!isReadMode && hasTouchedRequiredCustomerFields) {
                <mat-icon [@fadeInOut] 
                [ngClass]="{
                    'valid-icon': areRequiredCustomerFieldsDirty && areRequiredCustomerFieldsComplete, 
                    'invalid-icon': areRequiredCustomerFieldsDirty && !areRequiredCustomerFieldsComplete
                }">{{(areRequiredCustomerFieldsDirty && areRequiredCustomerFieldsComplete) || areRequiredCustomerFieldsComplete ? 'check_circle' : 'error'}}</mat-icon>
            }
            </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="mt-2">
            <lib-file-group 
                [isReadMode]="isReadMode"
                [baseForm]="customerForm"
                [fileForms]="customerPayslipForm"
                [stepperPatientForm]="stepperForm.controls['customerFiles']"
                [accordionSetup]="customerAccordionSetup"
            ></lib-file-group>
        </div>
    </mat-expansion-panel>

    @if (patientsArray) {
    <!-- @for (patientForm of isCustomerAPatient ? patientsArray.controls : patientsArrayWithoutCustomer; track patientForm.value; let i = $index) -->
    @for (patientForm of patientsArrayWithoutCustomer; track patientForm.value; let i = $index)
    {
    <mat-expansion-panel (afterCollapse)="markPatientFormTouched(patientForm)">
        <mat-expansion-panel-header
            [style.background-color]="!areRequiredPatientFieldsComplete(patientForm, i) && hasTouchedRequiredPatientFields(patientForm, i) ? 'rgb(237 20 61 / 20%)' : ''"
        >
            <mat-panel-title>{{toTitle(patientForm.get('title')?.value)}} {{patientForm.get('lastName')?.value || ''}}</mat-panel-title>
            <mat-panel-description>Patient ({{i + 1}})

            @if (!isReadMode && hasTouchedRequiredPatientFields(patientForm, i)) {
                <mat-icon [@fadeInOut] 
                [ngClass]="{
                    'valid-icon': areRequiredPatientFieldsDirty(patientForm, i) && areRequiredPatientFieldsComplete(patientForm, i),
                    'invalid-icon': areRequiredPatientFieldsDirty(patientForm, i) && !areRequiredPatientFieldsComplete(patientForm, i)
                }"
                >{{(areRequiredPatientFieldsDirty(patientForm, i) && areRequiredPatientFieldsComplete(patientForm, i)) || areRequiredPatientFieldsComplete(patientForm, i) ? 'check_circle' : 'error'}}</mat-icon>
            }
            </mat-panel-description>
        </mat-expansion-panel-header>
        
        <div class="mt-2">

            <lib-file-group 
                [isReadMode]="isReadMode"
                [baseForm]="patientForm"
                [stepperPatientForm]="getStepperFormOfPatient(patientForm)"
                [accordionSetup]="patientAccordionSetup"
            ></lib-file-group>
        </div>
    </mat-expansion-panel>
    }
    }

</mat-accordion>

<!-- Debug section:: -->
<!-- <br>
<hr>
<h4>stepperForm.valid: <span [ngClass]="{
    'valid-icon': stepperForm.valid, 
    'invalid-icon': stepperForm.invalid
}">{{stepperForm.valid}}</span> </h4>
<p>
    {{errorsOf(stepperForm) | json}}
</p>
<hr>
<h4>customerFiles.valid: <span [ngClass]="{
    'valid-icon': stepperForm.controls['customerFiles'].valid, 
    'invalid-icon': stepperForm.controls['customerFiles'].invalid
}">{{stepperForm.controls['customerFiles'].valid}}</span> </h4>
<p>
    {{errorsOf(stepperForm.controls['customerFiles']) | json}}
</p>

<hr>
@for (patientForm of patientsStepperArray.controls; track $index) {
    <h4>patientForm.valid: <span [ngClass]="{
        'valid-icon': patientForm.valid, 
        'invalid-icon': patientForm.invalid
    }">{{patientForm.valid}}</span></h4>
    <p>
        {{errorsOf(patientForm) | json}}
    </p>
} -->